// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-50[data-v-7b1db27d]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}", ""]);
// Exports
module.exports = exports;
